import "./sensors.css";
import { useContext, useEffect, useMemo, useRef, useState } from "react";

import Tabmenu, { TabMenuType } from "../../components/tabmenu/Tabmenu";


import { convertTimeString, getCurrentDate } from "../../utils/TimeUtils";
import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../components/button/MasterButton";
import refreshIcon from "../../assets/RefreshIcon.svg";

import InputfieldWithPlaceholder, { InputfieldType } from "../../components/inputfieldwithplaceholder/Inputfieldwithplaceholder";
import { SearchIcon } from "../../assets/SearchIcon";
import { ClearIcon } from "../../assets/ClearIcon";

import TableViews from "../../components/tableViews/tableViews"

import { useSelector , useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../context/store';

import { fetchUnattachedSensorDetails, reloadUnattachedSensorDetails } from '../../context/content/sensorsPage/unAttachedSensorsSlice';
import { fetchAttachedSensorDetails, reloadAttachedSensorDetails } from '../../context/content/sensorsPage/attachedSensorsSlice';

import Skeleton from "../../components/skeleton/Skeleton";

type TabMenuValues = {
  [key: string]: number;
};

const SensorsTabMenuValues: TabMenuValues = {
  Attached: 0,
  Unattached: 0,
};

type SensorDetails = {
  participantID: string; // Example: 'LAS001NNN'
  healthScore: number; // Value from 1 to 10
  sensorID: string; // 12 digit Hexadecimal Format
  sensorBattery: number; // Value from 0 - 100
  lastSyncTime: string; // Time data type
  firstSyncTime: string; // Time data type
  provisionTime: string; // Time data type
  organizationName: string; // Example: 'org-A'
  studyName: string; // Example: 'study-A'
  pinnedStatus: boolean;
  syncStatus: string;
};

type TableOptions = {
  tabName: string;
  isStudySelected: boolean;
  isStudyOrgSelected: boolean;
  networkError: boolean;
  isLoading: boolean;
}

const TableOptions : TableOptions = {
  tabName: "Sensors",
  isStudySelected: false,
  isStudyOrgSelected: true,
  networkError: false,
  isLoading: true,
}



interface SensorDetailsObject {
  [key: string]: SensorDetails[];
}

const SensorDetailsStore : SensorDetailsObject = {
  AttachedSensorDetailsArray : [],
  UnattachedSensorDetailsArray : [],
}

const Sensors = () => {

  const [isLoading, setLoading] = useState(true);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [searchActive, setSearchActive] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const [refreshDate, setRefreshDate] = useState(getCurrentDate());

  const [searchQuery, setSearchQuery] = useState("");

  const [placeholderValue, setplaceholderValue] = useState("");

  const [isRefreshing, setRefereshing] = useState(false);

  const [studyNameFromStore, setStudyNameFromStore] = useState("");
  const [studyOrgFromStore, setStudyOrgFromStore] = useState("");



  const dispatch: AppDispatch = useDispatch();


  const unAttachedSensorsDetailsUpdates = useSelector((state : RootState) => state.unAttachedSensorsDetails);
  const attachedSensorsDetailsUpdates = useSelector((state : RootState) => state.attachedSensorsDetails);

  useEffect(() => {
    SensorDetailsStore['AttachedSensorDetailsArray'] = attachedSensorsDetailsUpdates['sensors']
    SensorDetailsStore['UnattachedSensorDetailsArray'] = unAttachedSensorsDetailsUpdates['sensors']

  }, [attachedSensorsDetailsUpdates, unAttachedSensorsDetailsUpdates])

  useEffect(() => {
    dispatch(fetchAttachedSensorDetails());
    dispatch(fetchUnattachedSensorDetails());
  }, [dispatch]);


  



  const search = (query: string) => {
    console.log("Search Query:", query);
    setSearchQuery(query);
  };
  
  // Initialize an empty array of any type
  const [items, setItems] = useState<SensorDetails[]>([]);




  const storeStudy = useSelector((state: RootState) => state.studyInfo);

  const [tableOptions, setTableOptions] = useState<TableOptions>({
    tabName: "Sensors",
    isStudySelected: false,
    isStudyOrgSelected: false,
    networkError: false,
    isLoading: true,
  });

  useEffect(()=> {

    let StudyOrg = storeStudy.study.StudyOrg
    let StudyName = storeStudy.study.StudyName

    setStudyOrgFromStore(StudyOrg);
    setStudyNameFromStore(StudyName);
    
    if (storeStudy) {
      if(StudyOrg == "All Studies"){
        setTableOptions({
          tabName: "Sensors",
          isStudySelected: false,
          isStudyOrgSelected: false,
          networkError: false,
          isLoading: false,
        });
        setplaceholderValue("Enter ID, Org or Study")
      }else if(StudyName == ""){
        setTableOptions({
          tabName: "Sensors",
          isStudySelected: false,
          isStudyOrgSelected: true,
          networkError: false,
          isLoading: false,
        });
        setplaceholderValue("Enter ID or Study")
      }else{
        setTableOptions({
          tabName: "Sensors",
          isStudySelected: true,
          isStudyOrgSelected: true,
          networkError: false,
          isLoading: false,
        });
        setplaceholderValue("Enter ID")
      }
    }


  }, [storeStudy])

  useEffect(() => {

    if(selectedTabIndex === 0){
      setItems(filteredData.AttachedSensorDetailsArray)
    }else if(selectedTabIndex === 1){
      setItems(filteredData.UnattachedSensorDetailsArray)
    }

  }, [selectedTabIndex, searchQuery, attachedSensorsDetailsUpdates, unAttachedSensorsDetailsUpdates, studyNameFromStore, studyOrgFromStore] )


  let filteredData = Object.fromEntries(
    Object.entries(SensorDetailsStore).map(([key, SensorDetailsArray]) => {
      const filteredArray = SensorDetailsArray.filter((item: SensorDetails) => {
        return (
          item.participantID.toString().toUpperCase().includes(searchQuery.toUpperCase()) ||
          item.sensorID.toString().toUpperCase().includes(searchQuery.toUpperCase()) ||
          (tableOptions.isStudyOrgSelected === false && item.organizationName.toString().toUpperCase().includes(searchQuery.toUpperCase())) ||
          (tableOptions.isStudySelected === false && item.studyName.toString().toUpperCase().includes(searchQuery.toUpperCase()))
        );
      });
      return [key, filteredArray];
    })
  );

  filteredData = Object.fromEntries(
    Object.entries(filteredData).map(([key, ParticipantDetailsArray]) => {
      const filteredArray = ParticipantDetailsArray.filter((item: SensorDetails) => {
        if(studyOrgFromStore.toUpperCase() == "ALL STUDIES"){
          return true;
        }else if(studyNameFromStore.toUpperCase() == ""){
          return(
            item.organizationName.toString().toUpperCase().includes(studyOrgFromStore.toUpperCase())
          )
        }else{
          return (
            item.studyName.toString().toUpperCase().includes(studyNameFromStore.toUpperCase()) &&
            item.organizationName.toString().toUpperCase().includes(studyOrgFromStore.toUpperCase())
          );
        }
      });
      return [key, filteredArray];
    })
  );



  useEffect(() => {
    if(items.length > 0){
      setLoading(false)
    }
  }, [items.length])


  const reloadData = async () => {
    console.log("Reloading Data from Database");
  
    setRefereshing(true);
  
    try {
      // Dispatch the action to reload data
      await dispatch(reloadUnattachedSensorDetails());
      await dispatch(reloadAttachedSensorDetails());
      // Wait for data to reload and then update the refresh date
      setRefreshDate(getCurrentDate());
    } catch (error) {
      console.error("Error reloading data:", error);
    } finally {
      // Ensure isRefreshing is set to false regardless of success or failure
      setRefereshing(false);
    }
  };


    return (
      <>
        <div className="sensors-page">
          <div className="tab-header">
            <div className="left-section">
              <div className="title headline-small">Sensors</div>
              <Tabmenu
                isDisabled={false}
                isLoading={isLoading}
                items={[
                  {
                    type: TabMenuType.ACTIVE,
                    title: "Attached",
                    value: filteredData.AttachedSensorDetailsArray.length,
                  },
                  {
                    type: TabMenuType.UNASSIGNED,
                    value: filteredData.UnattachedSensorDetailsArray.length,
                    title: "Unattached",
                  },
                ]}
                onTabSelected={(index) => {
                  if (index !== selectedTabIndex) {
                    if (!searchActive) {
                      // loadSingleTab(selectedStudy, index);
                    }
                    setSelectedTabIndex(index);
                    scrollRef.current?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  }
                }}
              ></Tabmenu>

            </div>

            <div className="quick-actions">
            <div className={`body-small refresh-date ${isRefreshing ? "loading" : ""}`}>
              {isRefreshing ? "Refreshing..." : `Updated on ${refreshDate}`}
            </div>
              <MasterButton
                options={{
                  layoutType: ButtonLayoutType.IconLabel,
                  label: "Refresh",
                  variation: ButtonVariation.Outlined,
                  icon: refreshIcon,
                  size: ButtonSize.Medium,
                }}
                onClick={() => {
                  console.log("master button refresh");
                  reloadData()
                  // loadData(selectedStudy); // !!!!!!!!!!!!! Need to use the studyInfo state here to get the relevant study and load the data through the API
                }}
              ></MasterButton>
              <InputfieldWithPlaceholder
                collapsable={true}
                leftIcon={<SearchIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")}></SearchIcon>}
                rightActionIcon={<ClearIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")} />}
                onRightActionClicked={() => {
                  setSearchQuery("");
                  search("");
                  setSearchActive(false);
                }}
                value={searchQuery}
                onValueChanged={(value) => {
                  if (value !== "") {
                    setSearchActive(true);
                  } else {
                    setSearchActive(false);
                  }
                  setSearchQuery(value);
                  search(value);
                }}
                type={searchActive && items.length === 0 ? InputfieldType.Error : InputfieldType.Normal}
                placeholderValue={placeholderValue}
              ></InputfieldWithPlaceholder>

            </div>

          </div>

          <div className="content">

            <div className="static-place-holder"></div>
            <div className="table-info-section">
              {isLoading ? (
              <Skeleton></Skeleton>
              ) : (
                <>
                  <span className="display-small">{items.length}</span>
                  <span>&nbsp;</span>
                  <span className="title-small">Participants</span>
                </>
              )}
            </div>

            <div className="separator"></div>

            <TableViews TableDataArray={items} TableOptions={tableOptions}></TableViews>

          </div>
          
        </div>
      </>
    );
};

export default Sensors; 